export const ENTITIES = {
  TASK: 'task',
  TICKET: 'ticket',
};

export const NOTIFICATION_ENTITY_TYPES = {
  'CrmLevel::Task': ENTITIES.TASK,
  'CrmLevel::Ticket': ENTITIES.TICKET,
};

export const TICKET_NOTIFICATION_KINDS = {
  MENTIONED: 'mentioned',
  REMINDER: 'reminder',
  STATUS_CHANGED: 'status_changed',
  RELATION_CHANGED: 'relation_changed',
  ASSIGNED: 'assigned',
};

export const TASK_NOTIFICATION_KINDS = {
  TASK_ASSIGNED: 'task_assigned',
  REMINDER: 'reminder',
  TASK_STATUS_CHANGED: 'task_status_changed',
  TASK_COMMENT_CREATED: 'task_comment_created',
  DEADLINE_APPROACHING: 'deadline_approaching',
};

export const TASK_NOTIFICATION_TEXTS = {
  [TASK_NOTIFICATION_KINDS.TASK_ASSIGNED]: 'назначил(а) на вас новую задачу',
  [TASK_NOTIFICATION_KINDS.TASK_STATUS_CHANGED]: 'изменил(а) статус задачи',
  [TASK_NOTIFICATION_KINDS.TASK_COMMENT_CREATED]:
    'оставил(а) комментарий к задаче',
  [TASK_NOTIFICATION_KINDS.DEADLINE_APPROACHING]: 'Приближается дедлайн задачи',
  [TASK_NOTIFICATION_KINDS.REMINDER]: 'Напоминание по задаче',
};
